import { useSnackbar } from 'notistack'
import { useQuery } from 'react-query'
import { getCustomer } from 'services/cm-api/get-customer'

export function useCustomer(customerId: string | number) {
  const { enqueueSnackbar } = useSnackbar()

  return useQuery(
    ['getCustomer', customerId],
    () => getCustomer(Number(customerId)),
    {
      enabled: Boolean(customerId),
      onError: (err) => {
        enqueueSnackbar('Cannot get customer', { variant: 'error' })
      },
    },
  )
}
